$.preloadImages = function (imagesArray) {
    for (var key in imagesArray) {
        $("<img>").attr("src", imagesArray[key]);
    }
};
